import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 group cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-105">
                  <span className="text-background-50 font-heading text-base font-bold">91</span>
                </div>
                <span className="font-heading text-lg text-background-50 whitespace-nowrap">
                  91网页版入口
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                91网页版入口是您访问91平台最便捷的方式，无需下载客户端，打开浏览器即可直接进入，体验完整功能。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base mb-4">内容分类</h4>
              <div className="flex flex-col gap-2">
                {categories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base mb-4">常用链接</h4>
              <div className="flex flex-col gap-2">
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  首页
                </Link>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </Link>
                <Link
                  to="/category/faq-solutions"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  常见问题
                </Link>
                <a
                  href="/sitemap.xml"
                  className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  网站地图
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-background-50 text-base mb-4">联系方式</h4>
              <div className="flex flex-col gap-2 text-sm text-background-400">
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  <span>contact@91web.example.com</span>
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  <span>400-000-9100</span>
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-map-pin-line"></i>
                  <span>中国上海市浦东新区</span>
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-500">
              <p>&copy; {currentYear} 91网页版入口. 保留所有权利.</p>
              <div className="flex items-center gap-6">
                <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">
                  隐私政策
                </a>
                <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer">
                  服务条款
                </a>
                <a href="#" className="hover:text-background-300 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
                  免责声明
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}